import { type Cycle } from 'modules/core/components/DateNavigator/cycleUtils'
import { makeTypedEvent } from 'modules/core/lib/Tracking/typedEvents'

export const events = {
  openInsightsPage: 'Go to insights page',
  filterOpened: 'Insights filter opened',
  filterSelected: 'Insights filter selected',
  filtersCleared: 'Insights filters cleared',
  granularViewOpened: 'Insights granular view opened',
  granularViewTabChanged: 'Insights granular view tab changed',
  granularViewExport: 'Insights granular view export',
  fullPageExport: 'Insights full page export',

  headcountPage: {
    open: makeTypedEvent<{ action: HeadcountWidgetAction }>('Open insights headcount page'),

    cycleSelectorOpened: makeTypedEvent('Insights cycle selector opened'),
    cycleChanged: makeTypedEvent<{ cycle: Cycle }>('Insights cycle changed'),
    dateRangeSelectorOpened: makeTypedEvent('Insights date range selector opened'),
    dateRangeChanged: makeTypedEvent('Insights date range changed'),

    subRangeSelected: makeTypedEvent<{ action: SubRangeSelectionAction }>(
      'Insights headcount page sub range selected'
    ),

    export: makeTypedEvent<{ tab: 'headcount' | 'joiners' | 'leavers' }>(
      'Insights headcount page export'
    ),
  },
}

export type HeadcountWidgetAction = 'tooltip' | 'bottom-axis' | 'details-link'

export type SubRangeSelectionAction = HeadcountWidgetAction | 'date-range-navigator'
